import React from "react";

import { Title } from "./styles";

interface HeaderContentProps {
  text: string;
}

export const HeaderContent = ({ text }: HeaderContentProps) => {
  return <Title>{text}</Title>;
};
